angular.module('edxPd')
  .controller('EdxPdController', [
    '$filter',
    '$state',
    '$log',
    'authentication',
    'dblIaplService',
  function (
    $filter,
    $state,
    $log,
    dblAuthentication,
    dblIaplService
  ) {
    var vp = this;
    var authCustomer = dblAuthentication.getCustomer();
    $state.params.districtId = authCustomer.district_id;

    vp.modules = [];

    var groupByModule = function (pdContents) {
      var modules = {};
      var addedDisplayNames = [];
      _.forEach(pdContents, function(lesson, key) {
        var module = modules[lesson.moduleName];
        var isAcademic = lesson.moduleName !== 'na';
        if (module === undefined) {
          module = {
            academic: isAcademic,
            name: lesson.moduleName,
            sorter:  isAcademic ? 1 : 0,
            lessons: [],
            showLessons: true
          };
          modules[lesson.moduleName] = module;
        }

        lesson.sorter = isAcademic ? lesson.link : parseInt(lesson.lessonGroupName.substring(3)); // starts with 'na-' for non academic links
          var displayName = lesson.lessonName + lesson.pageTitle;
          if (_.indexOf(addedDisplayNames, displayName) < 0) {
              addedDisplayNames.push(displayName);
              module.lessons.push(lesson);
          }
      });

      return _.values(modules);
    };

    var initializeData = function() {
      vp.loadingPage = true;

      dblIaplService.getPdContents()
        .then(function(data) {
            vp.modules = groupByModule(data);
        }).finally(function() {
            vp.loadingPage = false;
        });
    };

    vp.handleRowClick = function(module) {
      module.showLessons = !module.showLessons;
    };

    initializeData();
  }]);
